import { API } from '@/api';

export const classes = {
  titleWrapper: 'place-between grow-0 py-2 px-3',
  message: 'mt-4 text-center text-taupe-1 text-base dark:text-mauve-3',
  newNoteWrapper: 'pb-0 px-1 shrink-0',
  timeline: 'flex-1 grow overflow-y-auto pb-4 px-1 shrink-0',
  addNoteButton: 'text-brand-accent dark:text-brand-accent-dark',
};

export async function createFileNote(fileId: number, content: string) {
  return API.Files.addNoteToFile(fileId, {
    note: { content },
  });
}
